import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface ProofOfEarningsSendingBottomSheetProps {
  modalState: UseModalState;
}

export function ProofOfEarningsSendingBottomSheet(props: ProofOfEarningsSendingBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet canDismiss={false} modalState={modalState}>
      <BottomSheetLoadingContent
        title="Sending proof of earnings"
        description="This should only take a few seconds"
      />
    </BottomSheet>
  );
}
